module.exports = __webpack_public_path__ + "img/POP-00013-3.8c17b066.png";